// 子仓库-养老
import to from 'await-to-js';
import * as apis from "@/api/interface/rxa";

export default {
  namespaced: true,
  state: () => ({
    liveClueList: undefined, //线索管理-列表
    liveClueCallDetail: undefined, //线索管理 - 获取通话详情
    qywxShiftList: undefined, //企微排班管理 - 获取列表
    seatFollowList: undefined, //坐席跟进管理 - 列表
  }),
  getters: {},
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
  },
  actions: {
    // 线索管理-列表
    async getLiveClueList(ctx, payload = {}) {
      const [err, res] = await to (apis.getLiveClueList(payload));
      ctx.commit("update", {
        liveClueList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 线索管理-选项
    async getLiveClueOptions(_ctx, payload = {}) {
      const [, res] = await to (apis.getLiveClueOptions(payload));
      return res;
    },
    // 线索管理-乳腺癌筛选选项集合
    async getRxaOptions(_ctx, payload = {}) {
      const [, res] = await to (apis.getRxaOptions(payload));
      return res;
    },
    // 线索管理 - 获取优化师选项列表
    async getUserNameOptions(_ctx, payload = {}) {
      const [, res] = await to (apis.getUserNameOptions(payload));
      return res;
    },
    // 线索管理-互动状态修改
    async liveClueStatusUpdate(_ctx, payload = {}) {
      const [, res] = await to(apis.liveClueStatusUpdate(payload));
      return res;
    },
    // 线索管理-主播排期模板下载
    async liveClueDownSchduleTemplate(_ctx, payload = {}) {
      const [, res] = await to(apis.liveClueDownSchduleTemplate(payload));
      return res;
    },
    // 线索管理-数据导出
    async liveClueExport(_ctx, payload = {}) {
      const [, res] = await to(apis.liveClueExport(payload));
      return res;
    },
    // 线索管理-上传主播排期表
    async liveClueAnchorSchdueUpload(_ctx, payload = {}) {
      const [, res] = await to(apis.liveClueAnchorSchdueUpload(payload));
      return res;
    },
    // 线索管理-获取核保材料详情
    async getLiveClueMaterialDetail(_ctx, payload = {}) {
      const [, res] = await to(apis.getLiveClueMaterialDetail(payload));
      return res;
    },
    // 线索管理-核保材料更新
    async liveClueMaterialUpdate(_ctx, payload = {}) {
      const [, res] = await to(apis.liveClueMaterialUpdate(payload));
      return res;
    },
    // 线索管理-核保材料提交审核
    async liveClueMaterialReview(_ctx, payload = {}) {
      const [, res] = await to(apis.liveClueMaterialReview(payload));
      return res;
    },

    // 线索管理 - 获取通话详情
    async getLiveClueCallDetail(ctx, payload = {}) {
      const [err, res] = await to (apis.getLiveClueCallDetail(payload));
      ctx.commit("update", {
        liveClueCallDetail: !err && res.data ? res.data : undefined,
      });
    },


    // 线索录入-获取月费
    async getClueYlMonthlyFee(_ctx, payload = {}) {
      const [, res] = await to (apis.getClueYlMonthlyFee(payload));
      return res;
    },
    // 线索录入-获取线索详情
    async getClueDetailFromPhone(_ctx, payload = {}) {
      const [, res] = await to (apis.getClueDetailFromPhone(payload));
      return res;
    },
    // 线索录入-单条新增
    async addClueEnter(_ctx, payload = {}) {
      const [, res] = await to (apis.addClueEnter(payload));
      return res;
    },
    // 线索录入-批量新增
    async batchAddClueEnter(_ctx, payload = {}) {
      const [, res] = await to (apis.batchAddClueEnter(payload));
      return res;
    },
    // 线索录入-上传批量添加模板
    async uploadBatchAddClueTemplate(_ctx, payload = {}) {
      const [, res] = await to (apis.uploadBatchAddClueTemplate(payload));
      return res;
    },


    // 企微排班管理 - 获取列表
    async getQywxShiftList(ctx, payload = {}) {
      const [err, res] = await to (apis.getQywxShiftList(payload));
      const weekFileds = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
      function weekFiledsMap(r) {
        weekFileds.forEach(field=> {
          r[field] = r[field] === 1 ? true : false;
          r[`${field}Shift`] = [undefined, null, ''].includes(r[`${field}Shift`]) ? 1 : r[`${field}Shift`];
        })
        return r;
      }

      ctx.commit("update", {
        qywxShiftList: !err && res.data ? res.data.map(weekFiledsMap) : undefined,
      });
      return res;
    },
    // 企微排班管理 - 新增
    async qywxShiftAdd(_ctx, payload = {}) {
      const [, res] = await to(apis.qywxShiftAdd(payload));
      return res;
    },
    // 企微排班管理 - 保存
    async qywxShiftSave(_ctx, payload = {}) {
      const [, res] = await to(apis.qywxShiftSave(payload));
      return res;
    },
    // 企微排班管理 - 保存班次
    async qywxShiftSaveShift(_ctx, payload = {}) {
      const [, res] = await to(apis.qywxShiftSaveShift(payload));
      return res;
    },
    // 企微排班管理 - 下线
    async qywxShiftOffline(_ctx, payload = {}) {
      const [, res] = await to(apis.qywxShiftOffline(payload));
      return res;
    },
    // 企微排班管理 - 启用
    async qywxShiftEnable(_ctx, payload = {}) {
      const [, res] = await to(apis.qywxShiftEnable(payload));
      return res;
    },
    

    // 坐席跟进管理 - 获取列表
    async getSeatFollowList(ctx, payload = {}) {
      const [err, res] = await to(apis.getSeatFollowList(payload));
      ctx.commit('update', {
        seatFollowList: !err && res && res.data ? res.data : undefined,
      });
      return res;
    },
  },
  modules: {},
};
